//-------------------------------
//
//  生年月日
//
//-------------------------------
const birthday_value = document.getElementById("birthday-value");
//  生年月日セット
const birthday_inputs = document.querySelectorAll(`.c-input-birthday select`);
/**
 *
 *
 *
 * 年月日のinputを渡してYYYY年MM月DD日の形式データをhiddenにセットする
 * @param {NodeListOf<HTMLInputElement> | HTMLInputElement[]} inputs
 */
function setBirthdayData(inputs) {
    const year = exchangeHyphenToZero(inputs[0].value);
    const month = exchangeHyphenToZero(inputs[1].value);
    const day = exchangeHyphenToZero(inputs[2].value);
    const date = `${Number(year)}年${Number(month)}月${Number(day)}日`;
    birthday_value.value = date;
}
/**
 *
 *
 *
 *  「--」を「00」に変換して返す
 * @param {string} dateString
 *
 */
function exchangeHyphenToZero(string) {
    if (string === "--") {
        return "00";
    } else {
        return string;
    }
}
//-------------------------------
//
//  住所
//
//-------------------------------

//  郵便番号
const input_postcode = document.getElementById("postcode");
//  住所
const input_prefecture = document.getElementById("prefecture");
const input_address1 = document.getElementById("address_main");
const input_address2 = document.getElementById("address_sub");
const address_inputs = [input_prefecture, input_address1, input_address2];
//  value設定input（住所全まとめ）
const address_value = document.getElementById("address-value");
if (address_value) {
    address_inputs.forEach((input) => {
        if (input.tagName === "SELECT") {
            input.addEventListener("change", () => {
                setAddressData(address_inputs);
            });
        }
        if (input.tagName === "INPUT") {
            input.addEventListener("blur", () => {
                setAddressData(address_inputs);
            });
        }
    });
}

function setAddressData(inputs) {
    const prefecture = input_prefecture.value;
    const address1 = input_address1.value;
    const address2 = input_address2.value;

    const address = `${prefecture}${address1}${address2 ? " " + address2 : ""}`;
    address_value.value = address;
}
//-------------------------------
//
//  パラメータ（決済ページURL用）
//
//-------------------------------
let pack_urls = [];
let prm_value = "";
if (typeof paymentUrls !== "undefined") {
    pack_urls = paymentUrls;
    if (!paymentUrls) {
        console.error("必須：パラメータ用URLが存在しません。");
        //  PHP側から受け取ったURL群を使用
    }
    prm_value = document.getElementById("prm");
    if (!prm_value) {
        console.error("必須：パラメータ用inputが存在しません。");
        //  通知メールに記載する決済ページへのURLをセットするinput
        //  PHP側から受け取ったURL群を使用
    }
}

//-------------------------------
//
//  購入パック
//
//-------------------------------
const pack_id_value = document.getElementById("pack_id");
const packs_row = document.getElementById("row-pack");
const pack_inputs = packs_row ? packs_row.querySelectorAll("input") : [];

/**
 *
 *
 *
 * input群の中でcheckがついている要素のpack_idをhidden要素にセットする
 * @param {NodeListOf<HTMLInputElement> | HTMLInputElement[]} inputs
 */
function setPackValue(inputs, urls) {
    inputs.forEach((input) => {
        const status = input.checked;
        if (status) {
            const pack_id = input.getAttribute("data-id");
            prm_value.value = urls[pack_id];
        }
    });
}
//-------------------------------
//
//  eラーニング開始月設定
//
//-------------------------------

//  eラーニング開始月input
const e_learning = document.getElementById("row-e-learning");
const e_learning_input_0 = document.getElementById("e-learning-0");
const e_learning_input_1 = document.getElementById("e-learning-1");
const e_learning_input_2 = document.getElementById("e-learning-2");
const date_button_1 = document.querySelector(`[for="e-learning-1"]`);
const date_button_2 = document.querySelector(`[for="e-learning-2"]`);
//  選択中の希望日
const selected_date = document.getElementById("select-exam-date");
//  講座付き検定パックinput
const packList = document.getElementById("row-pack");
const packs = packList ? packList.querySelectorAll(`input`) : [];
const course_pack_ids = ["normal_pack", "pro_pack", "course_only"];

const select_ng_message = `<span>検定対策講座の申し込み期限を過ぎているため、ご希望の受検日でこのパックは選択できません。別の受検日を選択してください。</span>`;
//  選択不可アラート表示
const e_learning_alert = document.querySelector(".c-input-e-learning__alert");

/**
 *
 *
 *
 *  タイムゾーンの影響を受けずに日付データを整形
 * @param {string} dateString YYYY-MM-DD形式の日付
 *
 */
function formatDate(dateString) {
    const year = dateString.getFullYear();
    const month = String(dateString.getMonth() + 1).padStart(2, "0");
    const day = String(dateString.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

/**
 *
 *
 *
 *  基準の日付から指定した月数を遡った1日の日付を返す
 * @param {string} dateString YYYY-MM-DD形式の日付
 * @param {Number} monthsAgo 何か月前の月を返すか
 * @param {Number} day 日付を何日にするか
 *
 */
function getStartDay(dateString, monthsAgo, day) {
    const date = new Date(dateString);
    date.setDate(day);
    date.setMonth(date.getMonth() - monthsAgo);
    return formatDate(date);
}

/**
 *
 *
 *
 *  YYYY-MM-DD形式の日付を◯月◯日に変換して返す（表示用の日付）
 * @param {string} dateString YYYY-MM-DD形式の日付
 *
 */
function formatMonthDay(dateString) {
    const [, month, day] = dateString.split("-");
    return `${Number(month)}月${Number(day)}日`;
}

/**
 *
 *
 *
 *  本日が指定日を過ぎているか判定
 * @param {string} dateString YYYY-MM-DD形式の日付
 * @returns {boolean} - true（過ぎていない） or false（過ぎている）
 *
 */
function isPastOrToday(dateString) {
    const today = new Date("2026-06-21");
    const target = new Date(dateString);

    // 時刻を0:00に揃える
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    return today <= target;
}

/**
 *
 *
 *
 *  基準の日付（受検希望日）を基にeラーニング開始月の選択可否と対策講座付き検定パックの選択可否を判定
 * @param {string} dateString YYYY-MM-DD形式の日付
 */
function judgeELearningStartDays(dateString) {
    //  対策講座付きパックの選択可否
    let select_course_pack = true;

    //  1か月前の1日／エントリー期限
    const month_ago_1 = getStartDay(dateString, 1, 1);
    const limit_month_1 = getStartDay(month_ago_1, 1, 20);
    //  2か月前の1日／エントリー期限
    const month_ago_2 = getStartDay(dateString, 2, 1);
    const limit_month_2 = getStartDay(month_ago_2, 1, 20);

    //  エントリー期限が本日を過ぎているか検証（bool値）
    const entry_date_1 = isPastOrToday(limit_month_1);
    const entry_date_2 = isPastOrToday(limit_month_2);

    if (!entry_date_1 && !entry_date_2) {
        //  どちらのエントリー期限も過ぎている場合
        select_course_pack = false;
    }

    return {
        entry_day_1: month_ago_2, //近い日付を前に
        entry_day_2: month_ago_1, //遠い日付を後に
        day_1_entry_result: entry_date_2,
        day_2_entry_result: entry_date_1,
        course_pack: select_course_pack,
    };
}
/**
 *
 *
 *
 * input群の中でNGではない最初のradioにチェックを付ける
 * @param {NodeListOf<HTMLInputElement> | HTMLInputElement[]} inputs
 */
function checkFirstAvailableRadio(inputs) {
    const radioArray = [...inputs];

    radioArray.forEach((input) => {
        input.checked = false;
    });

    const firstAvailable = radioArray.find((input) => {
        const button = input.closest(".c-input-pack__button, .c-input-e-learning__button");
        return button && !button.classList.contains("ng");
    });

    if (firstAvailable) {
        firstAvailable.checked = true;
    }
}
/**
 *
 *
 *
 *  受検希望日を基に「eラーニング開始月」と「希望パック」の選択可否を状態反映する
 * @param {string} dateString YYYY-MM-DD形式の日付
 */
function setELearningStatus(dateString) {
    //  eラーニング開始月取得
    const day_1 = judgeELearningStartDays(dateString).entry_day_1;
    const day_2 = judgeELearningStartDays(dateString).entry_day_2;
    //  各開始月の選択可否取得
    const day_1_result = judgeELearningStartDays(dateString).day_1_entry_result;
    const day_2_result = judgeELearningStartDays(dateString).day_2_entry_result;
    //  希望パック（対策講座付き）の選択可否
    const pack_result = judgeELearningStartDays(dateString).course_pack;

    //  ボタンに日付反映
    if (date_button_1) {
        const btn_span_1 = date_button_1.querySelector("span");
        btn_span_1.innerHTML = formatMonthDay(day_1);
    }
    if (date_button_2) {
        const btn_span_2 = date_button_2.querySelector("span");
        btn_span_2.innerHTML = formatMonthDay(day_2);
    }

    if (e_learning_input_1 && e_learning_input_2) {
        //  日付データセット
        e_learning_input_1.setAttribute("value", formatMonthDay(day_1));
        e_learning_input_1.setAttribute("data-date", day_1);
        e_learning_input_2.setAttribute("value", formatMonthDay(day_2));
        e_learning_input_2.setAttribute("data-date", day_2);
        //  本日の日付に応じて選択不可に設定
        if (!day_1_result) {
            date_button_1.classList.add("ng");
            e_learning_input_1.checked = false;
        } else {
            date_button_1.classList.remove("ng");
            e_learning_input_1.checked = true;
        }
        if (!day_2_result) {
            date_button_2.classList.add("ng");
            e_learning_input_2.checked = false;
        } else {
            date_button_2.classList.remove("ng");
            e_learning_input_2.checked = true;
        }
    }
    packs.forEach((el) => {
        const button = el.closest(".c-input-pack__button");
        const ng_tag = button.querySelector(".c-input-pack__ng");

        if (course_pack_ids.includes(el.getAttribute("data-id"))) {
            if (!pack_result) {
                button.classList.add("ng");
                ng_tag.innerHTML = select_ng_message;
            } else {
                button.classList.remove("ng");
                ng_tag.innerHTML = "";
            }
        }
    });

    checkFirstAvailableRadio(packs);
}

//-------------------------------
//
//  ロード時の処理
//
//-------------------------------
//  eラーニング開始月設定
const first_exam = document.getElementById("exam-day-1")
    ? document.getElementById("exam-day-1").getAttribute("data-exam")
    : "";
if (first_exam) {
    //  選択中の受験希望日表示
    if (selected_date) {
        selected_date.innerHTML = formatMonthDay(first_exam);
    }
    //  ステータス取得
    const result = judgeELearningStartDays(first_exam);
    //  生年月日登録
    setBirthdayData(birthday_inputs);
    //  住所登録
    setAddressData(address_inputs);
    //  eラーニング関連設定
    setELearningStatus(first_exam);
    //  選択中のパック登録
    setPackValue(pack_inputs, pack_urls);
}

// paymentUrls.forEach((url) => {
//     console.log(paymentUrls);
// });
//-------------------------------
//
// ボタンアクション
//
//-------------------------------
//  希望受検日（ボタン）
const exam_day_input = document.querySelectorAll(".c-input-exam-day__button input");
exam_day_input.forEach((input) => {
    input.addEventListener("change", () => {
        const exam_day = input.getAttribute("data-exam");
        //  選択中の受験希望日表示
        if (selected_date) {
            selected_date.innerHTML = formatMonthDay(exam_day);
        }
        //  ステータス取得
        const result = judgeELearningStartDays(exam_day);

        //  eラーニング関連設定
        setELearningStatus(exam_day);
        //  選択中のパック登録
        setPackValue(pack_inputs, pack_urls);
    });
});
//  生年月日
birthday_inputs.forEach((input) => {
    input.addEventListener("change", () => {
        setBirthdayData(birthday_inputs);
    });
});
//  購入パック
pack_inputs.forEach((input) => {
    input.addEventListener("click", () => {
        setPackValue(pack_inputs, pack_urls);
    });
});
